<template>
  <div ref="video" class="page video background"></div>
</template>

<script>
import brightcovePlayerLoader from '@brightcove/player-loader';

export default {
  name: 'PageVideo',
  props: {
    config: {
      type: Object,
      required: true,
    },
    video: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      videoLoaded: false,
      videoEl: null,
    }
  },
  computed: {
    bcAccount() {
      return this.config.brightcove.account;
    },
    bcPlayer() {
      return this.config.brightcove.player;
    }
  },
  methods: {
    loadPlayer() {
      try {
        brightcovePlayerLoader({
          refNode: this.$refs['video'],
          refNodeInsert: 'append',
          accountId: this.bcAccount,
          playerId: this.bcPlayer,
          videoId: this.video.src,
          embedOptions: {
            responsive: true,
            tagName: 'video',
          },
          onSuccess: () => {
            this.onLoaded();
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    reset() {
      this.videoEl.currentTime = 0;
    },
    pause() {
      if (!this.videoEl.paused) {
        this.videoEl.pause();
      }
    },
    play() {
      this.videoEl.play();
    },
    onLoaded() {
      this.videoEl = this.$refs['video'].querySelector('video');
      this.videoEl.controls = false;
      this.videoEl.addEventListener('timeupdate', event => this.onTimeUpdate(event));
      this.videoEl.addEventListener('ended', event => this.onEnded(event));

      if (this.chapter) {
        this.pause();
        this.videoEl.currentTime = this.chapter.start;
      }
      if (this.autoplay) {
        this.play();
      }
    },
    onTimeUpdate(event) {
      if (this.chapter && 
          this.chapter.end > -1 && 
          event.target.currentTime >= this.chapter.end)
      {
        this.pause();
        this.onEnded();
      }
    },
    onEnded() {
      this.$emit('action', { type: 'close-video', data: { phase: this.video.phase, pass: true, score: 1 } });
    }
  },
  mounted() {
    this.loadPlayer();
    setTimeout(() => this.play(), 500);
  },
}
</script>